// extracted by mini-css-extract-plugin
export default {"root":"ImprintPage--root--2U3O3","subtitle":"ImprintPage--subtitle--1dP76","text":"ImprintPage--text--2sb6J","img":"ImprintPage--img--1PTdt"};